import makeLookupModal from "../../UI/LookupModal/LookupModal";
import ProspectSourceLookup from "./ProspectSourceLookup";
const ProspectSourceLookupModal = makeLookupModal(ProspectSourceLookup, {
    pluralEntityName: "Prospect Sources",
});
export default ProspectSourceLookupModal;
